import { Reducer } from 'react';
import { SetStepAction, SetTotalPriceAction, State, ToggleSegmentAction } from './types';

export const reducer: Reducer<State, ToggleSegmentAction | SetStepAction | SetTotalPriceAction> = (state, action) => {
	switch (action.type) {
		case 'setTotalPrice': {
			return {
				...state,
				totalPrice: action.payload
			};
		}

		case 'toggleSegment':
			if (state.selectedSegments.includes(action.payload)) {
				return {
					...state,
					selectedSegments: state.selectedSegments.filter(segment => segment !== action.payload)
				};
			} else {
				return {
					...state,
					selectedSegments: state.selectedSegments.concat([action.payload])
				};
			}

		case 'setStep':
			return {
				...state,
				step: action.payload
			};
	}
};
